import { useCallback, useContext } from 'react'
import { AppStateContext } from './AppStateContext'

interface Auth2FAResult {
  saveAuth2FA: (twoFA: string | undefined) => void
  removeAuth2FA: () => void
}

export const useAuth2FA: () => Auth2FAResult = () => {
  const { setAuth2FAInStore, removeAuth2FAFromStore } = useContext(AppStateContext)
  const saveAuth2FA = useCallback((twoFA: string | undefined) => setAuth2FAInStore(twoFA), [setAuth2FAInStore])

  const removeAuth2FA = useCallback(() => removeAuth2FAFromStore(), [removeAuth2FAFromStore])

  return {
    saveAuth2FA,
    removeAuth2FA,
  }
}
